import { Icon, type IconName } from '@/ui/icons/Icon';
import { formatAmountWithSpaces } from '@/lib/amountUtils';
import styles from './FinalOfferChangesBanner.module.scss';

// The preliminary credit next to the final one, when ANAF changed it.
export interface OfferChanges {
  amountLabel: string;
  previousAmount: number;
  amount: number;
  previousRate: number;
  rate: number;
}

// Navigation state of the confirmation pages, opened from the chosen
// preliminary credit.
export interface OfferChangesState {
  offerChanges?: OfferChanges;
}

const formatRate = (rate: number) => `${rate.toFixed(1).replace('.', ',')}%`;

interface FinalOfferChangesBannerProps {
  changes: OfferChanges;
  onClose: () => void;
}

export function FinalOfferChangesBanner({
  changes,
  onClose,
}: FinalOfferChangesBannerProps) {
  const rows: { icon: IconName; label: string; from: string; to: string }[] = [
    {
      icon: 'coins',
      label: changes.amountLabel,
      from: formatAmountWithSpaces(changes.previousAmount),
      to: formatAmountWithSpaces(changes.amount),
    },
    {
      icon: 'percent',
      label: 'DAE',
      from: formatRate(changes.previousRate),
      to: formatRate(changes.rate),
    },
  ];
  const changedRows = rows.filter((row) => row.from !== row.to);

  return (
    <section className={styles.root}>
      <div className={styles.header}>
        <h2 className={styles.title}>Avem oferta finală! 🎉</h2>
        <p className={styles.description}>
          În urma verificării veniturilor, oferta ta a fost actualizată.
        </p>
      </div>
      {changedRows.map((row) => (
        <div key={row.label} className={styles.row}>
          <span className={styles.rowIcon} aria-hidden>
            <Icon name={row.icon} size={20} />
          </span>
          <span className={styles.rowLabel}>{row.label}</span>
          <span className={styles.rowFrom}>{row.from}</span>
          <Icon name="arrow-right" size={16} className={styles.rowArrow} />
          <span className={styles.rowTo}>{row.to}</span>
        </div>
      ))}
      <button
        type="button"
        className={styles.close}
        aria-label="Închide"
        onClick={onClose}
      >
        <Icon name="times" size={16} />
      </button>
    </section>
  );
}
